import { getAgrBracketFromAges } from '../../selectors/select-age-bracket';
import { getCustomerAges } from '../../selectors/select-youth-discount-ages';
import type { Customer } from '../../selectors/select-customer/types';

const getCustomerAgeBracket = (customer: Partial<Pick<Customer, 'members'>> | null) =>
  getAgrBracketFromAges(getCustomerAges(customer));

export default getCustomerAgeBracket;
